"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultScheduler = void 0;
const async_mutex_1 = require("async-mutex");
const WorkerError_1 = require("../error/WorkerError");
class DefaultScheduler {
    constructor(workerFactory, taskQueue, maxWorkers = DefaultScheduler.MAX_WORKERS) {
        this.taskInProgressIds = new Set([]);
        this.workerFactory = workerFactory;
        this.taskQueue = taskQueue;
        this.maxWorkers = maxWorkers;
        this.semaphore = new async_mutex_1.Semaphore(this.maxWorkers);
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            let nextTask = yield this.taskQueue.getNextTask({ blacklist: new Set(this.taskInProgressIds) });
            while (nextTask) {
                this.taskInProgressIds.add(nextTask.id);
                const [value, release] = yield this.semaphore.acquire();
                const worker = this.workerFactory.createWorker(nextTask);
                worker.run().then((result) => {
                    this.taskInProgressIds.delete(result.task.id);
                    this.taskQueue.completeTask(result.task.id);
                }).catch((error) => {
                    if (error instanceof WorkerError_1.WorkerError) {
                        const taskId = error.getTaskId();
                        this.taskInProgressIds.delete(taskId);
                    }
                }).finally(() => {
                    release();
                });
                if (this.semaphore.isLocked()) {
                    yield this.semaphore.waitForUnlock();
                }
                nextTask = yield this.taskQueue.getNextTask({ blacklist: new Set(this.taskInProgressIds) });
            }
        });
    }
}
exports.DefaultScheduler = DefaultScheduler;
DefaultScheduler.MAX_WORKERS = 5;
